import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  add_cto_category,
  update_cto_category,
} from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../../components/components-react/ReactAlert";

const validateForm = (formValues) => {
  const errors = {};

  if (!formValues.categoryName) {
    errors.categoryName = "Category name is required";
  }

  return errors;
};

const CTOCategoryForm = ({
  userInfoData,
  isEdit,
  rowData,
  cancelUpdate,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const iniFormValues = {
    categoryName: "",
    isActive: false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    setIsSubmit(false);

    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_cto_category : add_cto_category;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        cancelUpdate();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isEdit && rowData) {
      setFormValues((prevs) => ({
        ...prevs,
        categoryName: rowData?.category_name || "",
        isActive: rowData?.status === "active" ? true : false,
      }));
    } else {
      setFormValues(iniFormValues);
    }
  }, [isEdit, rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const requestBody = {
        category_name: formValues.categoryName || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit && rowData?.uid) {
        requestBody.uid = rowData?.uid;
      }

      const handleConfirm = async () => {
        handleAdd(requestBody);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`, "Edit", "Submit");
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="add-cto-container">
      <form className="formContainer w-60-per">
        <div className="formInputsGrid flexSystem">
          <div className="formInputBox">
            <input
              type="text"
              placeholder="Enter CTO Category Name"
              className={`formInput ${
                formErrors?.categoryName ? "formError" : ""
              }`}
              name="categoryName"
              value={formValues.categoryName}
              onChange={onChangeInput}
            />
          </div>

          {/* <div className="formInputBox formInputSwitchBox">
            <Form.Check
              type="checkbox"
              name="isActive"
              className={`${formErrors?.isActive ? "formError" : ""}`}
              label={`${formValues.isActive ? "Active" : "Inactive"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div> */}

          <div className="formInputBox checkbox-wrapper">
            <div className="flex-box" style={{ width: "auto" }}>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                {formValues.isActive ? "Active" : "Inactive"}
              </label>
            </div>
          </div>
        </div>
      </form>

      <div className="formButtons">
        <Button
          type="button"
          className="saveBtn"
          variant="dark"
          onClick={handleSubmit}>
          {isEdit ? "Update CTO Category" : "Add New CTO Category"}
        </Button>
        {isEdit && (
          <button
            type="button"
            className="cencelBtn"
            onClick={(e) => {
              e.preventDefault();
              cancelUpdate();
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default CTOCategoryForm;
